import React from 'react';
interface InputProps {
  label: string;
  type?: 'text' | 'email' | 'tel' | 'number';
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  prefix?: string | React.ReactNode;
  className?: string;
}
export function Input({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  required = false,
  prefix,
  className = ''
}: InputProps) {
  const id = `input-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return <div className={`flex flex-col ${className}`} data-id="element-225">
      <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-1.5 flex items-center" data-id="element-226">
        {label}
        {required && <span className="text-gray-400 text-xs font-normal ml-1.5" data-id="element-227">
            (Required)
          </span>}
      </label>
      <div className="relative" data-id="element-228">
        {prefix && <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 flex items-center justify-center" data-id="element-229">
            {prefix}
          </span>}
        <input id={id} type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} required={required} className={`w-full px-4 py-3.5 bg-gray-50 ${prefix ? 'pl-11' : ''} border border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-primary/10 focus:border-primary transition-all ${error ? 'border-red-500 ring-4 ring-red-500/10' : ''}`} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${id}-error` : undefined} data-id="element-230" />
      </div>
      {error && <p id={`${id}-error`} className="mt-1.5 text-sm text-red-500 font-medium" role="alert" data-id="element-231">
          {error}
        </p>}
    </div>;
}